import React, { createContext } from 'react';

export const mainContext = createContext({});